import { Html } from '@react-three/drei';

import { ReactComponent as Feather } from 'assets/svg/feather.svg';
import { ControlContext } from 'provider/ControlProvider';
import { memo, useContext } from 'react';

type Props = {
  name?: string;
  pos?: Array<number>;
  url?: string;
  index?: number;
  scale?: number;
};

const StoryButton = ({
  name = 'Chapter1',
  pos = [0, 0, 0],
  url = '/storylist/chapter1.jpg',
  scale = 0.4,
}: Props) => {
  const { setShowModal } = useContext(ControlContext);
  return (
    <Html
      scale={scale}
      transform
      sprite
      name={name}
      position={[pos[0], pos[1], pos[2]]}
    >
      <div className='w-80 flex flex-col items-center justify-center '>
        <button className='relative' onClick={() => setShowModal(5)}>
          <img
            src={url}
            className='border-4 w-76 h-76 select-none border-white rounded-full opacity-60 hover:opacity-100'
            alt='Spore&aposs Story Panel'
          />
        </button>
        <h3 className='relative text-white text-center text-5xl  p-2'>
          <Feather className='absolute -left-8 top-0 w-16 h-auto text-white' />
          {name}
        </h3>
      </div>
    </Html>
  );
};

export default memo(StoryButton);
